<p-table styleClass="mt-4" #grid [value]="mailsAccounts" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading" [paginator]="true"
          [rows]="50" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
          [rowsPerPageOptions]="[50,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th pSortableColumn="name">Nombre<p-sortIcon field="name"></p-sortIcon></th>
      <th width="250" pSortableColumn="unreadMailsCount">Sin leer <p-sortIcon field="unreadMailsCount"></p-sortIcon></th>
      <th width="130"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-mailAccount let-columns="columns">
    <tr (dblclick)="open(mailAccount.id)">      
      <td> {{mailAccount.name}} </td>
      <td>
        <div *ngIf="mailAccount.unreadMailsCount==0">No hay correos pendientes</div>
        <div *ngIf="mailAccount.unreadMailsCount>0" class="p-badge p-badge-warn">{{mailAccount.unreadMailsCount}} pendientes</div></td>
      <td>
        <div class="flex gap-2 justify-content-end">
          <p-button (click)="openInGuai(mailAccount.id)" [rounded]="true" [text]="false" severity="success"
                    pTooltip="Abrir el buzón dentro de GUAI"><i class="pi pi-inbox"></i></p-button>
          <p-button (click)="open(mailAccount.id)" [rounded]="true" [text]="true" severity="secondary"
                    pTooltip="Abrir en el webmail externo"><i class="pi pi-external-link"></i></p-button>
        </div>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
        <td [attr.colspan]="3">
            No se ha encontrado informes
        </td>
    </tr>
</ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>